import { SWIPE_MIN_DISTANCE_PX } from '../config/calendar-page.config';

type SwipePoint = { x: number; y: number };

export function getSwipeDirection(start: SwipePoint, end: SwipePoint): 'next' | 'previous' | null {
    const deltaX = end.x - start.x;
    const deltaY = end.y - start.y;

    if (Math.abs(deltaX) < SWIPE_MIN_DISTANCE_PX) return null;
    if (Math.abs(deltaY) > Math.abs(deltaX)) return null;

    return deltaX < 0 ? 'next' : 'previous';
}
